import type { TaskIconId } from "@oyako-flow/contracts";
export function TaskIcon({ id }: { id: TaskIconId }) {
  return (
    <img
      className="task-content-icon"
      src={`/task-icons/v1/${id}.svg`}
      width="68"
      height="68"
      alt=""
      aria-hidden="true"
      draggable={false}
      data-task-icon={id}
    />
  );
}
